import React from "react"
import { Stack, AppBar, Box, Typography } from "@mui/material"
import lsLogo from '../../Assets/mg-ls-web-flav.png'
import { useLSContext } from "../../Context/useLSContext";
import momentLogo from '../../Assets/Stacked Cursive - Cream.png';
import { EventSelector } from "./EventSelector";

interface LBHeaderProps {
    availableEvents: any;
    eventData: any;
    setEventData: (eventData: any) => void;
}
export const LBHeader = ({ availableEvents, eventData, setEventData }: LBHeaderProps) => {

    const {
        factor,
        windowSize,
    } = useLSContext();


    return (
        <AppBar id='leaderboard-header-ab' sx={{ height: 70,backgroundColor: 'primary.main', padding: '5px 20px', zIndex: 200
          , alignItems: 'flex-start', justifyContent: 'center'
         }}>
            <Stack direction={'row'} spacing={1} width={'100%'} justifyContent={'space-between'} alignItems='center'  > 

                <img src={momentLogo} alt="Live Scoring" 
                    style={{ height: 35 }} 
                />
                {!windowSize.isMobile && !windowSize.verticalMobile &&
                <EventSelector 
                    availableEvents={availableEvents}
                    eventData={eventData}
                    variant="standard"
                    color="secondary.main"
                    showStartAdornment={false}
                    adornmentOffset={60}
                    sx={{ 
                        padding: 3,
                        '& .MuiSvgIcon-root': {
                            color: 'secondary.main',
                        },
                    }}
                />
                }
                <Box sx={{ width: 50, alignItems: 'center', justifyContent: 'center'}}>
                    <img src={lsLogo} alt="Live Scoring" 
                        style={{ height: 50 * (factor < 1 ? factor : 1)}} 
                    /> 
                </Box>

            </Stack>
        </AppBar>
    )
}
